import { render, staticRenderFns } from "./SearchListDesktop.vue?vue&type=template&id=2826dcf1&scoped=true&"
import script from "./SearchListDesktop.vue?vue&type=script&lang=ts&"
export * from "./SearchListDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./SearchListDesktop.vue?vue&type=style&index=0&id=2826dcf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826dcf1",
  null
  
)

export default component.exports